module.exports = __webpack_public_path__ + "img/8.086712f1.png";